const l=l=>{var n,t;return(null===(n=null==l?void 0:l.installment)||void 0===n?void 0:n.quantity)?`parcelas-${null===(t=null==l?void 0:l.installment)||void 0===t?void 0:t.quantity}`:void 0};export{l as default};
